import { render, staticRenderFns } from "./DiceRoller.vue?vue&type=template&id=04453bf1&scoped=true&"
import script from "./DiceRoller.vue?vue&type=script&lang=js&"
export * from "./DiceRoller.vue?vue&type=script&lang=js&"
import style0 from "./DiceRoller.vue?vue&type=style&index=0&id=04453bf1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04453bf1",
  null
  
)

export default component.exports